exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".landing{background-color:var(--shopify);background-color:#fcbf67;width:100%}.feature-card{padding:20px;margin-left:auto;margin-right:auto}.card,.feature-card{box-shadow:0 .5rem 1rem rgba(0,0,0,.15);text-align:center}.card{padding:30px 20px 20px;margin-top:25px;border:none}.card img,.feature-card img{text-align:center;display:block;margin-left:auto;margin-right:auto;height:170px}.feature-card-title{margin-top:15px}.testimonial-card img{height:150px}.customer-image,.testimonial-card img{width:150px;border-radius:50%}.visit-platform-button{margin-top:33px;margin-bottom:12px}@media (max-width:768px){.card{margin-top:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62557fa6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home.vue
// module id = 31
// module chunks = 0